<template>
  <v-icon :icon="icon" :size="size" :color="color" :class="className" :data-testid="sectionTag" />
</template>

<script setup lang="ts">
/**
 * Decorative icon component (non-interactive)
 * Wraps v-icon to centralize usage and provide consistent defaults
 * For interactive icons, use WButton with variant="icon"
 *
 * @example <DecorativeIcon :icon="mdiCheck" />
 * @example <DecorativeIcon :icon="mdiStar" size="24" color="amber" />
 */
interface Props {
  /** MDI icon path */
  icon: string
  /** Icon size in pixels */
  size?: number | string
  /** Icon color (Vuetify color or hex) */
  color?: string
  /** Additional CSS classes */
  className?: string
  /** Automation tag (data-testid) */
  sectionTag?: string
}

withDefaults(defineProps<Props>(), {
  size: 20,
  color: 'inherit',
  className: '',
  sectionTag: 'icon'
})
</script>
